import styled from 'styled-components';

export const FieldWrap = styled.div`
  width: 100vw;
  height: 100vh;
  min-width: 100vw;
  max-height: 100vh;
  display: flex;
  overflow: hidden;
  .field-analysation-togggle {
    padding: ${({ theme }) => theme.spacing02};
  }

  .index-descriptions {
  }

  .field-panel-bottom-right {
    width: 100%;
    height: calc(40vh - 48px);
    display: flex;
    flex-direction: column;
    position: relative;
  }

  .field-panel-chart {
    height: 100%;
  }

  .field-filters {
    position: absolute;
    top: ${({ theme }) => theme.spacing01};
    right: ${({ theme }) => theme.spacing01};
    display: flex;
    gap: ${({ theme }) => theme.spacing01};
  }

  .button-select-new-field {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    border: none;
    background: none;
    font-size: ${({ theme }) => theme.fontSize03};
    color: ${({ theme }) => theme.colorText50};
    text-decoration: none;
    margin-bottom: ${({ theme }) => theme.spacing03};
    :hover {
      color: ${({ theme }) => theme.colorText70};
    }
    :hover svg {
      border: 1px solid ${({ theme }) => theme.colorUI50};
    }

    svg {
      margin-right: ${({ theme }) => theme.spacing01};
      border: 1px solid ${({ theme }) => theme.colorUI30};
      font-size: ${({ theme }) => theme.fontSize04};
      height: ${({ theme }) => theme.spacing04};
      width: ${({ theme }) => theme.spacing04};
      color: ${({ theme }) => theme.colorUI50};
      border-radius: ${({ theme }) => theme.borderRadius};
    }
  }

  .map-bottom-panel {
    position: absolute;
    z-index: 998;
    bottom: ${({ theme }) => theme.spacing01};
    left: ${({ theme }) => theme.spacing01};
  }

  .map-bottom-panel-higher {
    bottom: ${({ theme }) => theme.spacing04};
    left: ${({ theme }) => theme.spacing01};
  }

  .date-picker {
    margin-bottom: ${({ theme }) => theme.spacing02};
  }
  .button-white-medium-icon {
    color: ${({ theme }) => theme.colorPrimary50};
    font-size: ${({ theme }) => theme.fontSize04};
  }

  .field-information {
    display: flex;
    flex-wrap: wrap;
  }

  .field-information-stat-wrap {
    margin-right: ${({ theme }) => theme.spacing02};
    :nth-child(1) {
    }
    .field-information-stat {
    }
  }

  .field-information-stat {
    margin-right: ${(props) => props.theme.spacing03};
    display: flex;
    align-items: center;
    svg {
      margin-right: ${(props) => props.theme.spacing01};
      font-size: 30px;
      color: ${({ theme }) => theme.colorUI80};
      font-size: ${({ theme }) => theme.fontSize04};
      color: ${({ theme }) => theme.colorPrimary70};
    }
  }

  .fields-information-text {
    color: ${({ theme }) => theme.colorText50};
    text-transform: capitalize;
  }

  .field-information-stats {
    display: flex;
    flex-direction: column;
    padding-bottom: ${({ theme }) => theme.spacing02};
    margin-bottom: ${({ theme }) => theme.spacing02};
    border-bottom: 1px solid ${({ theme }) => theme.colorUI30};
  }
  .field-information-title {
    display: flex;
    margin-bottom: ${({ theme }) => theme.spacing02};
    .field-information-label {
      font-weight: ${({ theme }) => theme.fontWeightMedium};
      font-size: ${({ theme }) => theme.fontSize04};
      color: ${({ theme }) => theme.colorText70};
      margin-right: ${({ theme }) => theme.spacing01};
    }
    .field-information-id {
      color: ${({ theme }) => theme.colorText50};
      font-size: ${({ theme }) => theme.fontSize04};
      font-weight: ${({ theme }) => theme.fontWeightNormal};
    }
  }

  .observation-card-section {
    margin-top: ${({ theme }) => theme.spacing04};
    height: 100%;
    .observation-card-list-title {
      font-size: ${({ theme }) => theme.fontSize04};
      border-bottom: 1px solid ${({ theme }) => theme.colorUI30};
      padding-bottom: ${({ theme }) => theme.spacing01};
      margin-bottom: ${({ theme }) => theme.spacing03};
      color: ${({ theme }) => theme.colorText70};
    }
  }

  .chart-loader {
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .field-parameters {
    margin-top: ${({ theme }) => theme.spacing06};
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .field-performance-index-selector-list {
    margin-top: ${({ theme }) => theme.spacing02};
    flex-grow: 1;
    .field-performance-index-selector-background {
      height: 100%;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: 0.2s cubic-bezier(0.73, 0, 0.14, 0.53) transform;
      :hover {
        transform: scale(1.02);
        transition: 0.2s cubic-bezier(0.73, 0, 0.14, 0.53) transform;
      }
    }
    .field-performance-index-selector-item {
      height: 150px;
      color: #f4f4f4;
      font-size: 20px;
      letter-spacing: 0.2px;
      margin-bottom: ${({ theme }) => theme.spacing02};
      font-weight: ${({ theme }) => theme.fontWeightMedium};
      overflow: hidden;

      :hover {
        cursor: pointer;
        text-decoration: underline;
        color: white;
      }
      .performance-index-selector-item-icon {
        margin-left: ${({ theme }) => theme.spacing01};
      }
    }
  }
`;

export const ObservationCard = styled.div`
  padding-bottom: ${({ theme }) => theme.spacing03};
  .observation-card-information {
    margin-top: ${({ theme }) => theme.spacing01};
    display: flex;
    justify-content: space-between;
    align-items: center;
    .observation-card-information-title {
      color: ${({ theme }) => theme.colorText70};
    }
  }
`;

export const FieldTimelapse = styled.div`
  height: 100%;
  width: 100%;
  background: white;
  position: absolute;
  z-index: 1002;
`;

export const Map = styled.div`
  height: 60vh;
  z-index: 500;
  width: 100%;
`;

export const FieldPanelRight = styled.div`
  width: 100%;
  .field-panel-top-right {
    width: 100%;
    height: 100%;
    max-height: 60vh;
  }
`;

export const FieldStatusWrap = styled.div`
  height: 100vh;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
`;
